// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes homeFadeUp {
  from {
    opacity: 0;
    transform: translateY(24px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes homeFloat {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-12px);
  }
}
.homePage .homeAbout {
  padding: clamp(3.5rem, 8vw, 6rem) 0;
  background: #ffffff;
}
.homePage .homeAbout__inner {
  width: min(1120px, 100% - 2.5rem);
  margin-inline: auto;
  width: min(1120px, 100%);
}
.homePage .homeAbout__visual {
  border-radius: 28px;
  overflow: hidden;
  background: #f4f7fb;
  border: 1px solid rgba(26, 31, 44, 0.08);
}
.homePage .homeAbout__chart {
  display: block;
  width: 100%;
  height: auto;
}
.homePage .homeAbout__eyebrow {
  margin: 0 0 0.5rem;
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #1a9fd4;
}
.homePage .homeAbout__title {
  margin: 0 0 1rem;
  font-size: clamp(1.8rem, 3vw, 2.4rem);
  font-weight: 700;
  color: #1a1f2c;
}
.homePage .homeAbout__lead {
  margin: 0 0 1.75rem;
  font-size: 1.05rem;
  line-height: 1.7;
  color: #5c6578;
  max-width: 38rem;
}
.homePage .homeAbout__pillars {
  display: grid;
  gap: 1rem;
}
.homePage .homeAbout__pillar {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 0.9rem;
  align-items: start;
  padding: 0.85rem 0;
  border-top: 1px solid rgba(26, 31, 44, 0.08);
}
.homePage .homeAbout__pillar:last-child {
  border-bottom: 1px solid rgba(26, 31, 44, 0.08);
}
.homePage .homeAbout__pillar h3 {
  margin: 0 0 0.25rem;
  font-size: 1.05rem;
  font-weight: 600;
}
.homePage .homeAbout__pillar p {
  margin: 0;
  color: #5c6578;
  font-size: 0.95rem;
  line-height: 1.55;
}
.homePage .homeAbout__icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(63, 185, 234, 0.12);
  color: #1a9fd4;
  font-size: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/Components/Home/home-tokens.scss","webpack://./src/Components/Home/About/Style.scss"],"names":[],"mappings":"AA2BA;EACE;IACE,UAAA;IACA,2BAAA;EC1BF;ED4BA;IACE,UAAA;IACA,wBAAA;EC1BF;AACF;AD6BA;EACE;IAEE,wBAAA;EC5BF;ED8BA;IACE,4BAAA;EC5BF;AACF;AAfA;EACE,mCAAA;EACA,mBAAA;AAiBF;AAfE;EDMA,iCAAA;EACA,mBAAA;ECLE,wBAAA;AAkBJ;AAfE;EACE,mBAAA;EACA,gBAAA;EACA,mBDXQ;ECYR,wCAAA;AAiBJ;AAdE;EACE,cAAA;EACA,WAAA;EACA,YAAA;AAgBJ;AAbE;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cDxBa;ACuCjB;AAZE;EACE,gBAAA;EACA,qCAAA;EACA,gBAAA;EACA,cDrCO;ACmDX;AAXE;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cD3CS;EC4CT,gBAAA;AAaJ;AAVE;EACE,aAAA;EACA,SAAA;AAYJ;AATE;EACE,aAAA;EACA,+BAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,4CAAA;AAWJ;AATI;EACE,+CAAA;AAWN;AARI;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;AAUN;AAPI;EACE,SAAA;EACA,cDxEO;ECyEP,kBAAA;EACA,iBAAA;AASN;AALE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;EACA,cDjFa;ECkFb,eAAA;AAOJ","sourcesContent":["$home-ink: #1a1f2c;\r\n$home-muted: #5c6578;\r\n$home-line: rgba(26, 31, 44, 0.08);\r\n$home-mist: #f4f7fb;\r\n$home-paper: #ffffff;\r\n$home-teal: #3fb9ea;\r\n$home-teal-deep: #1a9fd4;\r\n$home-red: #d60000;\r\n$home-display: \"Plus Jakarta Sans\", system-ui, sans-serif;\r\n$home-body: \"Outfit\", system-ui, sans-serif;\r\n\r\n@mixin home-container {\r\n  width: min(1120px, calc(100% - 2.5rem));\r\n  margin-inline: auto;\r\n}\r\n\r\n@mixin home-reveal {\r\n  opacity: 0;\r\n  transform: translateY(28px);\r\n  transition: opacity 0.7s ease, transform 0.7s ease;\r\n\r\n  &.is-visible {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes homeFadeUp {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(24px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes homeFloat {\r\n  0%,\r\n  100% {\r\n    transform: translateY(0);\r\n  }\r\n  50% {\r\n    transform: translateY(-12px);\r\n  }\r\n}\r\n","@import \"../home-tokens.scss\";\n\n.homePage .homeAbout {\n  padding: clamp(3.5rem, 8vw, 6rem) 0;\n  background: $home-paper;\n\n  &__inner {\n    @include home-container;\n    width: min(1120px, 100%);\n  }\n\n  &__visual {\n    border-radius: 28px;\n    overflow: hidden;\n    background: $home-mist;\n    border: 1px solid $home-line;\n  }\n\n  &__chart {\n    display: block;\n    width: 100%;\n    height: auto;\n  }\n\n  &__eyebrow {\n    margin: 0 0 0.5rem;\n    font-size: 0.8rem;\n    font-weight: 600;\n    letter-spacing: 0.14em;\n    text-transform: uppercase;\n    color: $home-teal-deep;\n  }\n\n  &__title {\n    margin: 0 0 1rem;\n    font-size: clamp(1.8rem, 3vw, 2.4rem);\n    font-weight: 700;\n    color: $home-ink;\n  }\n\n  &__lead {\n    margin: 0 0 1.75rem;\n    font-size: 1.05rem;\n    line-height: 1.7;\n    color: $home-muted;\n    max-width: 38rem;\n  }\n\n  &__pillars {\n    display: grid;\n    gap: 1rem;\n  }\n\n  &__pillar {\n    display: grid;\n    grid-template-columns: auto 1fr;\n    gap: 0.9rem;\n    align-items: start;\n    padding: 0.85rem 0;\n    border-top: 1px solid $home-line;\n\n    &:last-child {\n      border-bottom: 1px solid $home-line;\n    }\n\n    h3 {\n      margin: 0 0 0.25rem;\n      font-size: 1.05rem;\n      font-weight: 600;\n    }\n\n    p {\n      margin: 0;\n      color: $home-muted;\n      font-size: 0.95rem;\n      line-height: 1.55;\n    }\n  }\n\n  &__icon {\n    width: 42px;\n    height: 42px;\n    border-radius: 12px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(63, 185, 234, 0.12);\n    color: $home-teal-deep;\n    font-size: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
